var render = function render(_c,_vm){return (_vm.props.value)?_c('div',{staticClass:"array-field__single-option",class:'background-color--' + _vm.props.value.color},[_c('div',{staticClass:"array-field__ellipsis"},[_vm._v(_vm._s(_vm.props.value.value))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }